export type ListingTypeOptions =
  | "Treatment"
  | "Package"
  | "Membership"
  | "Product"
  | "ProductFromExternalSource"
  | "GiftCard";

export const convertListingTypeToProductType = (type: ListingTypeOptions): string => {
  switch (type) {
    case "Membership":
      return "membership";
    case "GiftCard":
      return "gift card";
    case "Package":
      return "product bundle";
    case "Treatment":
      return "treatment";
    // The index's `ProductTypeConstants.RetailProduct`; SkinDrop and in-store retail share it.
    case "Product":
    default:
      return "retail product";
  }
};

export const convertProductTypeToListingType = (productType: string): ListingTypeOptions => {
  switch (productType) {
    case "treatment":
      return "Treatment";
    case "product bundle":
      return "Package";
    case "membership":
      return "Membership";
    case "gift card":
      return "GiftCard";
    case "retail product":
    default:
      return "Product";
  }
};

export const getListingPdpPath = (listingId: string, type: ListingTypeOptions): string => {
  if (type === "Membership") {
    return `/pdp/membership/${listingId}`;
  }
  if (type === "GiftCard") {
    return "/shop/gift-cards";
  }
  if (type === "Product" || type === "ProductFromExternalSource") {
    return `/pdp/product/${listingId}`;
  }
  return `/pdp/package/${listingId}`;
};
